import gql from 'graphql-tag';

// `input` carries the `version` the operator loaded as a root argument beside
// `defaultCoverageOptOutId` - the nested `DefaultCoverageOptOutUpdateInput` is
// only `{ startDate, endDate, clearEndDate, notes }` and rejects a `version`.
//
// A lost version race is flagged by `errorCode: 'STALE_VERSION'` (branched on
// exception class server-side, so it does not drift when the copy is reworded);
// `errors[0]` still carries the human sentence we display. The returned entry
// carries the new `version`, so the refetched row is immediately editable.
const updateDefaultCoverageOptOutMutation = gql`
  mutation UpdateDefaultCoverageOptOut(
    $input: UpdateDefaultCoverageOptOutInput!
  ) {
    updateDefaultCoverageOptOut(input: $input) {
      success
      errors
      errorCode
      defaultCoverageOptOutEntry {
        id
        buyerNumber
        sellerNumber
        auctionAccessNumber
        productId
        productCode
        startDate
        endDate
        notes
        status
        version
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;

export default updateDefaultCoverageOptOutMutation;
